import { useRouter } from "vue-router";


export function fashionUse() {

    const router = useRouter();


    async function goToEditorialGallery() {
        await router.push("/editorial-gallery");
        window.scrollTo(0, 0);
    }

    async function goToFashionEcommerceGallery() {
        await router.push("/fashion-ecommerce-gallery");
        window.scrollTo(0, 0);
    }


    return {
        goToEditorialGallery,
        goToFashionEcommerceGallery,
    };
}
